import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import paypalNewImg from "../../assest/images/Paypal2.png";
import paypalWhiteImg from "../../assest/images/Paypal_white.png";
import mbWayWhiteImg from "../../assest/images/mb-way-white2.png";
import mbWayImg from "../../assest/images/mb-way2.png";
import StripeCharge from "./Stripe";
import Paypal from "./Paypal";
import MbWay from "./MbWay";
import MultiBanco from "./MultiBanco";
// const StripeCharge = React.lazy(() => import("./Stripe"));


const Payment = ({
    activeTab,
    onClickPaymentTab,
    stripeSuccess,
    onClickContinue,
    amount,
    sendMbwayPaymentRequest,
    mbResponse,
    isMBLoading,
    generateMultiBancoRefrence,
    cartItem,
    isAdmin
}) => {

    const CashIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" >
            <path d="M11.1375 2.96248V5.81248H10.0125V2.96248C10.0125 2.75998 9.8325 2.66248 9.7125 2.66248C9.675 2.66248 9.6375 2.66998 9.6 2.68498L3.6525 4.92748C3.255 5.07748 3 5.45248 3 5.87998V6.38248C2.3175 6.89248 1.875 7.70998 1.875 8.63248V5.87998C1.875 4.98748 2.4225 4.19248 3.255 3.87748L9.21 1.62748C9.375 1.56748 9.5475 1.53748 9.7125 1.53748C10.4625 1.53748 11.1375 2.14498 11.1375 2.96248Z" fill="#5D4709" />
            <path d="M16.125 10.875V11.625C16.125 11.8275 15.9675 11.9925 15.7575 12H14.6625C14.265 12 13.905 11.7075 13.875 11.3175C13.8525 11.085 13.9425 10.8675 14.0925 10.7175C14.2275 10.575 14.415 10.5 14.6175 10.5H15.75C15.9675 10.5075 16.125 10.6725 16.125 10.875Z" fill="#5D4709" />
            <path d="M14.61 9.7125H15.375C15.7875 9.7125 16.125 9.375 16.125 8.9625V8.6325C16.125 7.08 14.8575 5.8125 13.305 5.8125H4.695C4.0575 5.8125 3.4725 6.0225 3 6.3825C2.3175 6.8925 1.875 7.71 1.875 8.6325V13.68C1.875 15.2325 3.1425 16.5 4.695 16.5H13.305C14.8575 16.5 16.125 15.2325 16.125 13.68V13.5375C16.125 13.125 15.7875 12.7875 15.375 12.7875H14.7225C14.0025 12.7875 13.3125 12.345 13.125 11.6475C12.9675 11.0775 13.155 10.53 13.53 10.1625C13.8075 9.8775 14.19 9.7125 14.61 9.7125ZM10.5 9.5625H5.25C4.9425 9.5625 4.6875 9.3075 4.6875 9C4.6875 8.6925 4.9425 8.4375 5.25 8.4375H10.5C10.8075 8.4375 11.0625 8.6925 11.0625 9C11.0625 9.3075 10.8075 9.5625 10.5 9.5625Z" fill="#5D4709" />
        </svg>
    );

    const CardIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M11.415 4.91248H4.335C4.125 4.91248 3.93 4.91998 3.75 4.92748C1.9725 5.03248 1.5 5.68498 1.5 7.70997V8.14497C1.5 8.55747 1.8375 8.89497 2.25 8.89497H13.5C13.9125 8.89497 14.25 8.55747 14.25 8.14497V7.70997C14.25 5.47498 13.68 4.91248 11.415 4.91248Z" fill="#5D4709" />
            <path d="M2.25 10.02C1.8375 10.02 1.5 10.3575 1.5 10.77V12.9525C1.5 15.1875 2.07 15.75 4.335 15.75H11.415C13.6425 15.75 14.2275 15.21 14.25 13.0725V10.77C14.25 10.3575 13.9125 10.02 13.5 10.02H2.25ZM5.22 13.92H3.9375C3.63 13.92 3.375 13.665 3.375 13.3575C3.375 13.05 3.63 12.795 3.9375 12.795H5.2275C5.535 12.795 5.79 13.05 5.79 13.3575C5.79 13.665 5.535 13.92 5.22 13.92ZM9.4125 13.92H6.8325C6.525 13.92 6.27 13.665 6.27 13.3575C6.27 13.05 6.525 12.795 6.8325 12.795H9.4125C9.72 12.795 9.975 13.05 9.975 13.3575C9.975 13.665 9.7275 13.92 9.4125 13.92Z" fill="#5D4709" />
            <path d="M16.5002 9.99751V6.06751C16.5002 3.72001 15.1577 2.70001 13.1327 2.70001H6.4352C5.8652 2.70001 5.3552 2.78251 4.9052 2.95501C4.5527 3.08251 4.2377 3.27001 3.9827 3.51751C3.8477 3.64501 3.9527 3.85501 4.1477 3.85501H12.3002C13.9877 3.85501 15.3527 5.22001 15.3527 6.90751V12.285C15.3527 12.4725 15.5552 12.5775 15.6902 12.4425C16.2077 11.895 16.5002 11.0925 16.5002 9.99751Z" fill="#5D4709" />
        </svg>
    );

    const MultiBancoIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 48 48" fill="none">
            <path fill="#1565c0" d="M39.498,12c-0.765,0-1.418-0.583-1.492-1.36l-0.12-1.28C37.814,8.585,37.172,8,36.393,8H11.607	c-0.779,0-1.421,0.585-1.493,1.359l-0.12,1.28c-0.078,0.825-0.811,1.44-1.634,1.354c-0.825-0.077-1.431-0.809-1.354-1.633l0.12-1.28	C7.345,6.754,9.271,5,11.607,5h24.786c2.336,0,4.262,1.754,4.48,4.08l0.12,1.28c0.077,0.824-0.529,1.556-1.354,1.633	C39.592,11.998,39.545,12,39.498,12z"></path>
            <path fill="#1565c0" d="M39.307,43H8.693c-1.237,0-2.433-0.518-3.28-1.419s-1.289-2.127-1.211-3.362l0.051-0.813	c0.052-0.827,0.756-1.457,1.591-1.403c0.827,0.052,1.455,0.764,1.403,1.591l-0.051,0.813c-0.026,0.417,0.117,0.815,0.404,1.12	C7.887,39.832,8.275,40,8.693,40h30.613c0.418,0,0.807-0.168,1.093-0.473c0.287-0.306,0.43-0.703,0.404-1.121l-0.051-0.813	c-0.052-0.827,0.577-1.539,1.403-1.591c0.829-0.054,1.539,0.576,1.591,1.403l0.051,0.813c0.077,1.235-0.364,2.461-1.211,3.362	S40.544,43,39.307,43z"></path>
            <path fill="#424242" d="M24.498,33c-0.752,0-1.401-0.561-1.488-1.327l-1.37-12.051l-4.755,11.453	C16.653,31.635,16.106,32,15.5,32s-1.153-0.365-1.385-0.925L9.36,19.622L7.99,31.673c-0.094,0.823-0.836,1.419-1.66,1.321	c-0.823-0.094-1.414-0.837-1.32-1.659l1.604-14.121c0.13-1.151,0.977-2.031,2.107-2.189c1.119-0.159,2.167,0.449,2.604,1.508	L15.5,26.588l4.176-10.058c0.436-1.058,1.482-1.665,2.603-1.506c1.13,0.158,1.977,1.038,2.107,2.189l1.604,14.121	c0.094,0.822-0.498,1.565-1.321,1.659C24.612,33.001,24.555,33,24.498,33z"></path>
            <path fill="#424242" d="M40.447,22.802c0.507-0.769,0.803-1.688,0.803-2.677c0-2.688-2.187-4.875-4.875-4.875H30.5	c-0.829,0-1.5,0.672-1.5,1.5v14.5c0,0.828,0.671,1.5,1.5,1.5h7.125c2.964,0,5.375-2.411,5.375-5.375	C43,25.445,41.978,23.751,40.447,22.802z M37.625,29.75H32v-11.5h4.375c1.034,0,1.875,0.841,1.875,1.875S37.409,22,36.375,22H35.5	c-0.829,0-1.5,0.672-1.5,1.5s0.671,1.5,1.5,1.5h2.125C38.935,25,40,26.065,40,27.375S38.935,29.75,37.625,29.75z"></path>
        </svg>
    );

    return (

        <div className="paymentTab">

            <Tabs
                // defaultActiveKey="cash"
                activeKey={activeTab}
                onSelect={(k) => onClickPaymentTab(k)}
                id="payment-tabs" className="mb-3" justify>
                {
                    isAdmin &&

                    <Tab eventKey="cash"
                        title={
                            <span className="d-inline-flex align-items-center gap-1">
                                <CashIcon />
                                <span>Cash</span>
                            </span>
                        }>
                        <div className="continueBox">
                            <button className="btn continueBtn" onClick={() => onClickContinue()}>Continue <i className="fa-solid fa-circle-arrow-right"></i></button>
                        </div>
                    </Tab>
                }
                <Tab eventKey="card"
                    title={
                        <span className="d-inline-flex align-items-center gap-1">
                            <CardIcon />
                            <span>Card</span>
                        </span>
                    }>
                    <div className="registerBox">
                        <StripeCharge stripeSuccess={stripeSuccess} cartItem={cartItem} />
                    </div>
                </Tab>
                <Tab eventKey="multibanco"
                    title={
                        <span className="d-inline-flex align-items-center gap-1">
                            <MultiBancoIcon />
                            <span>Multibanco</span>
                        </span>
                    }>

                    <MultiBanco
                        mbResponse={mbResponse}
                        isMBLoading={isMBLoading}
                        generateMultiBancoRefrence={generateMultiBancoRefrence}
                    />
                </Tab>
                <Tab eventKey="paypal" title={
                    <>
                        <img src={paypalNewImg} alt="paypal-new" className="black" width={65} style={{ verticalAlign: "textTop" }} />
                        <img src={paypalWhiteImg} alt="paypal-white" className="white" width={65} style={{ verticalAlign: "textTop" }} />

                    </>
                }>
                    <div className="registerBox amountDetail">
                        <Paypal stripeSuccess={stripeSuccess} cartItem={cartItem} />
                    </div>
                </Tab>
                <Tab eventKey="mbway" title={
                    <>
                        <img src={mbWayImg} alt="mb-way" className="black" style={{ verticalAlign: "textTop" }} width={45} />
                        <img src={mbWayWhiteImg} alt="mb-way-white" className="white" style={{ verticalAlign: "textTop" }} width={45} />
                    </>
                }>
                    <MbWay sendMbwayPaymentRequest={sendMbwayPaymentRequest} />
                </Tab>
            </Tabs>
        </div>
    )

}
export default Payment